import seedrandom from "seedrandom";
import QuestionModule from "./maths/modules/QuestionModule";

export default class WeeklyChallenge
{
    static generate(seeds)
    {
        const questions = P3.assets.json("questions");

        const blacklist1 = [];
        const blacklist2 = [];

        const countOccurrences = (arr, val) => arr.reduce((a, v) => (v === val ? a + 1 : a), 0);
        const filterQuestions = (difficulty) =>
        {
            let data = [];

            for (let i in questions)
            {
                if (questions.hasOwnProperty(i))
                {
                    if (i === QuestionModule.MODULE_TUTORIAL) continue;
                    if (countOccurrences(blacklist1, i) < 1)
                    {
                        const t = questions[i].filter(x => x.enabled && x.difficulty === difficulty);

                        for (let j = 0; j < t.length; ++j)
                        {
                            if (countOccurrences(blacklist2, i + "/" + t[j].type) < 1)
                            {
                                t[j].module = i;    // we add 'module' as a property
                                data.push(t[j]);
                            }
                        }
                    }
                }
            }
            return data;
        }

        const create = (index, seed, difficulty) =>
        {
            const rng = seedrandom(seed + difficulty + "");

            if (!WeeklyChallenge.questions[index])
            {
                WeeklyChallenge.questions[index] = {};
            }
            WeeklyChallenge.questions[index][difficulty] = [];

            for (let j = 0; j < 10; ++j)
            {
                const data = filterQuestions(difficulty);
                const i = Math.floor(rng() * data.length);
                const question = data[i];
                question.seed = seed;

                WeeklyChallenge.questions[index][difficulty].push(question);

                blacklist1.push(question.module);
                blacklist2.push(question.module + "/" + question.type);
            }

            blacklist1.length = 0;
            blacklist2.length = 0;
        }

        for (let i = 0; i < seeds.length; ++i)
        {
            const seed = seeds[i];

            create(i, seed, 0);
            create(i, seed, 1);
            create(i, seed, 2);
            create(i, seed, 3);
        }
    }

    static print()
    {
        let csv = "week,difficulty,no,module,type,view,input,seed,template\n";

        const append = (index, difficulty) =>
        {
            let csv = "";

            for (let j = 0; j < 10; ++j)
            {
                const question = WeeklyChallenge.questions[index][difficulty][j];

                csv += (index + 1) + "," +
                (question.difficulty + 1) + "," +
                (j + 1) + "," +
                question.module + "," +
                question.type + "," +
                question.view + "," +
                question.input + "," +
                question.seed + "," +
                (question.template ? question.template : "n/a") + "\n";
            }
            return csv;
        }

        for (let i = 0; i < WeeklyChallenge.questions.length; ++i)
        {
            csv += append(i, 0) + "\n";
            csv += append(i, 1) + "\n";
            csv += append(i, 2) + "\n";
            csv += append(i, 3) + "\n";
        }

        console.warn(csv);
        return csv;
    }
}

WeeklyChallenge.questions = [];